import type { SVGProps } from 'react';
const SvgLegendToggle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#legend_toggle_svg__a)">
      <path
        fill="currentColor"
        d="M20 15H4v-2h16v2Zm0 2H4v2h16v-2Zm-5-6 5-3.55V5l-5 3.55L10 5 4 8.66V11l5.92-3.61L15 11Z"
      />
    </g>
    <defs>
      <clipPath id="legend_toggle_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLegendToggle;
